import { render, staticRenderFns } from "./AlipayRecharge.vue?vue&type=template&id=bde13c6c&"
import script from "./AlipayRecharge.vue?vue&type=script&lang=js&"
export * from "./AlipayRecharge.vue?vue&type=script&lang=js&"
import style0 from "./AlipayRecharge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports